/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Smiley.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import happySvg from './happy.svg';
import smileSvg from './smile.svg';
import neutralSvg from './neutral.svg';
import sadSvg from './sad.svg';
import dizzySvg from './dizzy.svg';
import * as SmileyVariant from './smileyVariants';
import type { SmileyVariantType } from './smileyVariants';

const smileyVariantSettings = {
  [SmileyVariant.HAPPY]: {
    svg: happySvg,
    color: '#199F6E',
  },
  [SmileyVariant.SMILE]: { svg: smileSvg, color: '#2AA579' },
  [SmileyVariant.NEUTRAL]: { svg: neutralSvg, color: '#D27724' },
  [SmileyVariant.SAD]: { svg: sadSvg, color: '#DA5136' },
  [SmileyVariant.DIZZY]: { svg: dizzySvg, color: '#D10000' },
};

type Props = {
  className?: string,
  variant?: SmileyVariantType,
  isActive?: boolean,
  title?: string,
};

const useStyles = createUseThemeStyles(styles);

const AboutIcon = ({
  className,
  variant = SmileyVariant.HAPPY,
  isActive,
  title,
}: Props): React.Node => {
  const { color, svg } = smileyVariantSettings[variant];

  const classes = useStyles({ color });

  return (
    <BaseIcon
      className={classNames(classes.root, className, {
        [classes.active]: isActive,
      })}
      svg={svg}
      title={title}
    />
  );
};

export default React.memo<Props>(AboutIcon);
